<template>
    <div>
        <div v-if="view === 'page'" class="yq-page">
            <div class="yq-page-head">
                <div class="yq-page-name">{{template?template.name:(page?page.name:'')}}</div>
                <div class="yq-page-toolbar">
                    <el-link @click="configPage" :underline="false" icon="el-icon-setting">页面配置</el-link>
                    <el-link @click="addSection" :underline="false" icon="el-icon-plus">添加栏目</el-link>
                    <el-link @click="savePageConfig" :underline="false" icon="el-icon-check">保存布局</el-link>
                    <time-interval-picker v-model="timeInterval"></time-interval-picker>
                    <el-link @click="refresh" :underline="false" icon="el-icon-refresh">刷新</el-link>
                </div>
            </div>
            <grid-layout v-if="pageConfig"
                         :layout.sync="pageConfig.sections"
                         :col-num="24"
                         :row-height="30"
                         :is-draggable="true"
                         :is-resizable="true"
                         :is-mirrored="false"
                         :vertical-compact="true"
                         :margin="[10, 10]"
                         :use-css-transforms="true"
            >
                <grid-item v-for="item in pageConfig.sections"
                           :x="item.x"
                           :y="item.y"
                           :w="item.w"
                           :h="item.h"
                           :i="item.i"
                           :key="item.i" dragAllowFrom=".yq-section-head"
                           @moved="onSectionMoved"
                           @resized="onSectionResized">
                    <component :is="item.component" :id="item.id" :name="item.name" show-config-ui :refresh-id="item.refreshId"
                               @edit-section="editSection(item)" :page-id="isTemplate?null:idValue"
                               :template-id="isTemplate?idValue:null" @delete-section="deleteSection(item)"
                               :time-interval="timeInterval"></component>
                </grid-item>
            </grid-layout>
        </div>
        <div v-else-if="view === 'section'">
            <section-config :id="section.id" @close="onSectionConfigClose"></section-config>
        </div>
        <section-select :visible.sync="showSectionSelect" :on-select="onSectionSelect"
                        :enable-placeholder-section="isTemplate"></section-select>
        <el-dialog v-if="pageConfig" title="页面配置" :visible.sync="configDialogVisible">
            <el-form ref="configForm" :model="pageConfig" label-width="80px" :rules="configRules" size="mini">
                <el-form-item label="时间范围" prop="timeInterval">
                    <time-interval-picker v-model="pageConfig.timeInterval"></time-interval-picker>
                </el-form-item>
            </el-form>
            <div>
                <el-button @click="addDatasource" size="mini">添加数据源</el-button>
            </div>
            <div v-for="(ds,index) in pageConfig.datasources" :key="index">
                <el-divider></el-divider>
                <el-form ref="dsForm" :model="ds"
                         label-width="80px" :rules="dsRules" size="mini">
                    <el-form-item label="数据源" prop="datasource">
                        <datasource-select v-model="ds.datasource"></datasource-select>
                    </el-form-item>
                    <el-form-item label="检索条件" prop="queryConfig" v-if="ds.datasource">
                        <es-query-editor v-model="ds.queryConfig" :data-source-id="ds.datasource.id"></es-query-editor>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="deleteDatasource(index)">删除</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="configDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitConfigForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import pageTemplateService from '../../service/page-template'
    import pageService from '../../service/page'
    import sectionTypeService from '../../service/section-type'
    import VueGridLayout from 'vue-grid-layout'
    import SectionSelect from '../common/SectionSelect'
    import SectionConfig from '../sections/SectionConfig'
    import DatasourceSelect from '../common/DatasourceSelect'
    import TimeIntervalPicker from '../common/DateIntervalPicker'
    import EsQueryEditor from "../common/EsQueryEditor";
    import {buildQueryFromQueryConfig} from "../../service/EsQueryUtils";

    const uuidv4 = require('uuid/v4')

    export default {
        name: "SectionsPageConfig",
        props: ["id", "isTemplate"],
        components: {
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem,
            SectionSelect,
            SectionConfig,
            DatasourceSelect,
            TimeIntervalPicker,
            EsQueryEditor
        },
        computed:{
            idValue(){
                return this.id?parseInt(this.id):null
            }
        },
        data() {
            const checkDatasource = (rule, value, callback) => {
                if (value) {
                    for(const ds of this.pageConfig.datasources){
                        if(ds.datasource!==value && ds.datasource && ds.datasource.id === value.id){
                            callback(new Error('该数据源已存在'));
                            return
                        }
                    }
                    callback();
                } else {
                    callback();
                }
            }
            const checkQueryConfig = (rule, value, callback) => {
                if (value) {
                    const query = buildQueryFromQueryConfig(value)
                    if(query&&query.length>10000){
                        callback(new Error('长度不能超过 10000 个字符'))
                    }else{
                        callback()
                    }
                } else {
                    callback();
                }
            }
            return {
                template: null,
                page: null,
                pageConfig: null,
                showSectionSelect: false,
                onSectionSelect: () => {},
                dirty: false,
                view: 'page',
                section: null,
                configDialogVisible: false,
                configRules:{
                },
                dsRules:{
                    datasource: [
                        {required: true, message: '请选择数据源', trigger: 'blur'},
                        {validator: checkDatasource, trigger: 'blur'}
                    ],
                    queryConfig: [
                        {required: true, message: '请输入检索条件', trigger: 'blur'},
                        {validator: checkQueryConfig, trigger: 'blur'}
                    ]
                },
                timeInterval: null
            }
        },
        watch:{
            id(){
                this.init()
            }
        },
        created(){
            this.init()
        },
        methods: {
            async init(){
                try {
                    if (this.isTemplate) {
                        const response = await pageTemplateService.getPageTemplate(this.id)
                        this.template = response.data
                        this.pageConfig = this.getPageConfig(this.template)
                    } else {
                        const response = await pageService.getPage(this.id)
                        this.page = response.data
                        this.pageConfig = this.getPageConfig(this.page)
                    }
                    this.timeInterval = this.pageConfig.timeInterval
                    this.dirty = false
                } catch (e) {
                    this.$message({
                        type: 'error',
                        message: '请求出错!'
                    })
                }
            },
            getPageConfig(pageOrTemplate){
                let pageConfig
                if(pageOrTemplate.pageConfig){
                    pageConfig = this.parsePageConfig(pageOrTemplate.pageConfig)
                }else if(pageOrTemplate.config){
                    pageConfig = this.parsePageConfig(pageOrTemplate.config)
                }else{
                    pageConfig = {
                        datasources: [],
                        sections: [],
                        timeInterval: 'P1M'
                    }
                }
                return pageConfig
            },
            parsePageConfig(json){
                const pageConfig = JSON.parse(json)
                for (const section of pageConfig.sections) {
                    const sectionType = sectionTypeService.getSectionType(section.type)
                    section.component = section.id ? sectionType.component : sectionType.preview
                    section.refreshId = 0
                }
                if(!pageConfig.datasources){
                    pageConfig.datasources=[]
                }
                if(!pageConfig.sections){
                    pageConfig.sections=[]
                }
                if(!pageConfig.timeInterval){
                    pageConfig.timeInterval = 'P1M'
                }
                for(const ds of pageConfig.datasources){
                    if(!ds.queryConfig){
                        ds.queryConfig = ds.query
                    }
                }
                return pageConfig
            },
            addSection() {
                this.onSectionSelect = section => {
                    if(section){
                        this.addSectionToPage(section)
                    }
                }
                this.showSectionSelect = true

            },
            addSectionToPage(section) {
                let y = 0
                for (const item of this.pageConfig.sections) {
                    if (item.y + item.h > y) {
                        y = item.y + item.h
                    }
                }
                const sectionType = sectionTypeService.getSectionType(section.type)
                this.pageConfig.sections.push({
                    type: section.type,
                    name: section.name,
                    id: section.id,
                    x: 0,
                    y: y,
                    w: 12,
                    h: 10,
                    i: uuidv4().replace(/-/g, ''),
                    component: section.id ? sectionType.component : sectionType.preview
                })
                this.dirty = true
            },
            editSection(section) {
                if(section.id){
                    this.section = section
                    this.view = 'section'
                }else{
                    this.onSectionSelect = selectedSection => {
                        if(selectedSection){
                            section.id = selectedSection.id
                            section.name = selectedSection.name
                            section.type = selectedSection.type
                            const sectionType = sectionTypeService.getSectionType(section.type)
                            section.component = sectionType.component
                            this.dirty = true
                        }
                    }
                    this.showSectionSelect = true
                }
            },
            deleteSection(section) {
                const index = this.pageConfig.sections.indexOf(section)
                this.pageConfig.sections.splice(index, 1)
                this.dirty = true
            },
            onSectionMoved(){
                this.dirty = true
            },
            onSectionResized(){
                this.dirty = true
            },
            isDirty(){
                return this.dirty
            },
            async savePageConfig() {
                const pageConfig = JSON.parse(JSON.stringify(this.pageConfig))
                pageConfig.sections.forEach(item => {
                    delete item.moved;
                    delete item.component
                    delete item.refreshId
                })
                if(this.isTemplate){
                    this.template.pageConfig = JSON.stringify(pageConfig)
                    try {
                        await pageTemplateService.updatePageTemplatePageConfig(this.id, this.template)
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        })
                        this.dirty = false
                    } catch (e) {
                        this.$message({
                            type: 'error',
                            message: '保存失败!'
                        })
                    }
                }else{
                    this.page.config = JSON.stringify(pageConfig)
                    try {
                        await pageService.updatePageConfig(this.id, this.page)
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        })
                        this.dirty = false
                    } catch (e) {
                        this.$message({
                            type: 'error',
                            message: '保存失败!'
                        })
                    }
                }
            },
            async onSectionConfigClose(){
                this.section.refreshId++
                this.view = 'page'
            },
            configPage(){
                this.configDialogVisible = true
            },
            addDatasource(){
                this.pageConfig.datasources.push({
                    datasource: null,
                    query: null
                })
            },
            deleteDatasource(index){
                this.pageConfig.datasources.splice(index, 1)
            },
            async submitConfigForm(){
                const validatePromises = []
                if(Array.isArray(this.$refs.dsForm)){
                    validatePromises.push(...this.$refs.dsForm.map(form => form.validate()))
                }else if(this.$refs.dsForm){
                    validatePromises.push(this.$refs.dsForm.validate())
                }
                try {
                    await Promise.all(validatePromises)
                } catch (e) {
                    return
                }
                if(this.isTemplate){
                    const pageConfig = this.getPageConfig(this.template)
                    pageConfig.timeInterval = this.pageConfig.timeInterval
                    pageConfig.datasources = this.pageConfig.datasources.map(item => {
                        return {
                            datasource: {
                                id: item.datasource.id,
                                name: item.datasource.name,
                                type: item.datasource.type
                            },
                            queryConfig: item.queryConfig,
                            query: buildQueryFromQueryConfig(item.queryConfig)
                        }
                    })
                    pageConfig.sections.forEach(item => {
                        delete item.moved;
                        delete item.component
                        delete item.refreshId
                    })
                    this.template.pageConfig = JSON.stringify(pageConfig)
                    try {
                        await pageTemplateService.updatePageTemplatePageConfig(this.id, this.template)
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        })
                        this.configDialogVisible = false
                        this.pageConfig.sections.forEach(item => item.refreshId++)
                    } catch (e) {
                        this.$message({
                            type: 'error',
                            message: '保存失败!'
                        })
                    }
                }else{
                    const pageConfig = this.getPageConfig(this.page)
                    pageConfig.timeInterval = this.pageConfig.timeInterval
                    pageConfig.datasources = this.pageConfig.datasources.map(item => {
                        return {
                            datasource: {
                                id: item.datasource.id,
                                name: item.datasource.name,
                                type: item.datasource.type
                            },
                            queryConfig: item.queryConfig,
                            query: buildQueryFromQueryConfig(item.queryConfig)
                        }
                    })
                    pageConfig.sections.forEach(item => {
                        delete item.moved;
                        delete item.component
                        delete item.refreshId
                    })
                    this.page.config = JSON.stringify(pageConfig)
                    try {
                        await pageService.updatePageConfig(this.id, this.page)
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        })
                        this.configDialogVisible = false
                        this.pageConfig.sections.forEach(item => item.refreshId++)
                    } catch (e) {
                        this.$message({
                            type: 'error',
                            message: '保存失败!'
                        })
                    }
                }
            },
            refresh(){
                for(const section of this.pageConfig.sections){
                    section.refreshId++
                }
            }
        }
    }
</script>
<style scoped>

</style>
